import { map, mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { myDayTimetableService } from '../../../common/services';
import * as actionTypes from './actionTypes';
import * as myDayTimetableActions from './actions';

export function getMyDayTimetable(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_MYDAY_TIMETABLE),
    mergeMap(({ payload }) => {
      return myDayTimetableService.getMyDayTimetable(payload).pipe(
        map((res) =>
          myDayTimetableActions.getMyDayTimetableSuccess(
            res.responceObject.records
          )
        ),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}
